export const environment = {
  production: false,
  apiUrl: 'https://app-nezabutni-dev.azurewebsites.net/api',
  liqPay: {
    url: 'https://www.liqpay.ua/api/3/checkout',
  },
};
